import { render, staticRenderFns } from "./UserAuthorityShow.vue?vue&type=template&id=7e3056a2&"
import script from "./UserAuthorityShow.vue?vue&type=script&lang=ts&"
export * from "./UserAuthorityShow.vue?vue&type=script&lang=ts&"
import style0 from "./UserAuthorityShow.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports